import React from 'react'
import PropTypes from 'prop-types'

import currencyFormat from 'functions/currencyFormat'
import styles from './styles.scss'

const PriceRecommendation = (props) => {
  const {
    campaignProposal: {
      commission_fee, commission_structure, list_price_max, list_price_min,
    },
  } = props

  return (
    <section className={styles.root}>
      <span className={styles.title}>Based on the information presented we believe your property will be worth</span>
      <span className={styles.value}>
        {currencyFormat(list_price_min, '$0,0')} - {currencyFormat(list_price_max, '$0,0')}
      </span>

      <span className={styles.title}>Our Fee:</span>
      <span className={styles.value}>{commission_fee}%</span>

      {commission_structure && [
        <span key="label" className={styles.title}>Commission Structure:</span>,
        <span key="value" className={styles.value}>{commission_structure}%</span>,
      ]}
    </section>
  )
}

PriceRecommendation.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
}

export default PriceRecommendation
